import {Component, inject, OnInit} from '@angular/core';
import {AuthService} from '../../../core/services/auth.service';
import {AuthApiService} from "../../../core/services-api/auth-api.service";
import {SidebarService} from "../../../core/services/sidebar.service";
import {FiltersVisibilityService} from "../../../core/services/filters-visibility.service";
import { RouterOutlet } from "@angular/router";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { LeftMenuListComponent } from "../../../core/components/left-menu/left-menu-list/left-menu-list.component";
import { SidebarComponent } from "../../../core/components/sidebar/sidebar.component";

@Component({
  selector: 'app-home-page',
  standalone: true,
  imports: [
    RouterOutlet,
    LeftMenuListComponent,
    SidebarComponent
  ],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss',
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic'
      }
    }
  ]
})
export class HomePageComponent implements OnInit {
  private authService: AuthService = inject(AuthService);
  private authApiService: AuthApiService = inject(AuthApiService);
  private sidebarService: SidebarService = inject(SidebarService);
  private filtersVisibilityService: FiltersVisibilityService = inject(FiltersVisibilityService);

  public ngOnInit(): void {
    if (!this.authService.getUserRoles().length) {
      this.authApiService.manualRefreshTokens();
    }
  }

  public handleClickCloseSideBar(): void {
    if (this.sidebarService.isSidebarFolded) { return; }

    this.sidebarService.closeAllSubmenus();
    this.sidebarService.foldSidebar();
  }

  public handleClickCloseFilters(event: Event): void {
    if (event && this.isClickOnFilterButton(event)) { return; }

    this.filtersVisibilityService.resetFilterVisibility();
  }

  private isClickOnFilterButton(event: Event): boolean {
    const target = event.target as HTMLElement;
    return (
      target.closest('.filter-button') !== null ||
      target.closest('.filters-visible') !== null ||
      target.classList.contains('filter-button')
    );
  }
}
